import { Link } from 'react-router-dom';
import { useUnreadCount } from '../hooks/useNotifications.js';

/** A bell linking to the inbox, with an unread badge. */
export default function NotificationBell({ to, className = '' }) {
  const unread = useUnreadCount();
  return (
    <Link
      to={to}
      aria-label={unread ? `Notifications, ${unread} unread` : 'Notifications'}
      className={`relative flex min-h-touch min-w-touch items-center justify-center rounded-2xl text-heading transition-colors hover:bg-leaf-100 ${className}`}
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
      </svg>
      {unread > 0 && (
        <span className="absolute right-1.5 top-1.5 grid h-5 min-w-5 place-items-center rounded-full bg-persimmon px-1 text-2xs font-bold tabular-nums text-white">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </Link>
  );
}
